// For shimming all the webpack-flavor functionlity!
// So it can still work just as well in a node context!

// import fs from "fs"
// import path from "path"
// import * as stacktrace from "stack-trace"

// If you are NOT running from a browser window...
if(typeof window === "undefined") {
    // Shim all the browser window things!!
    global.window = global.window || {
        "environment": "node",
        "addEventListener": function() {},
        "requestAnimationFrame": function() {},
        "navigator": {
            "getGamepads": function() {
                return []
            }
        },
        "location": {
            "hostname": "",
        },
        "history": {
            "replaceState": {},
            "state": {
                "dataFolder": {
                    "getDirectoryHandle": function() {}
                }
            },
        },
        "performance": {
            "now": function() {}
        },
        "Audio": function() {
            return {}
        },
        "Image": function() {
            return {
                "addEventListener": function() {}
            }
        }
    }
    global.Audio = function() {
        return {}
    }
    global.Image = function() {
        return {
            "addEventListener": function() {}
        }
    }
    global.document = {
        "addEventListener": function() {},
        "getElementById": function() {
            return {}
        },
    }

    global.require = function(filepath) {
        // let filetype = path.extname(filepath)
        // if(filetype == "") {
        //     filepath = filepath + "/index.js"
        //     filetype = ".js"
        //     // NOTE WELL! THIS DOESN'T LOOK FOR .JSX!!
        // }
        // if(filetype == ".json") {
        // || filetype == ".js") {
        // if(filepath.endsWith(".json")) {
        //     let contents = undefined
        //     if(filepath.startsWith(".")) {
        //         const callsite = stacktrace.get()[1]
        //         if(callsite.getFileName instanceof Function) {
        //             const calldir = path.dirname(callsite.getFileName()).replace("file://", "")
        //             filepath = path.join(calldir, filepath)
        //             console.log(filepath)
        //         }
        //     }
        //     if(filepath.startsWith("@fae/")) {
        //         const rootpath = path.normalize(process.cwd())
        //         filepath = filepath.replace("@fae", rootpath)
        //     }
        //     // if(filetype == "" && fs.existsSync(path.join(filepath + "/index.js"))) {
        //     //     contents = fs.readFileSync(path.join(filepath + "/index.js"))
        //     //     filetype = ".js"
        //     // } else if(filetype == "" && fs.existsSync(filepath + ".js")) {
        //     //     contents = fs.readFileSync(filepath + ".js")
        //     //     filetype = ".js"
        //     // } else
        //     if(fs.existsSync(filepath)) {
        //         contents = fs.readFileSync(filepath)
        //     } else if(fs.existsSync("node_modules/" + filepath)) {
        //         contents = fs.readFileSync("node_modules/" + filepath)
        //     } else {
        //         throw new Error("Could not find " + filepath)
        //     }
        //     // if(filetype == ".js") {
        //     //     // contents = eval(contents.toString())
        //     // } else if(filetype == ".json") {
        //     contents = JSON.parse(contents)
        //     // }
        //     // If you are using a require to import a .js file,
        //     // we ... just aren't loading it. We'll give you an
        //     // empty object instead. So don't put anything you
        //     // want to run headlessly in a require!!
        //
        //     return contents
        // }
        return {}
    }
}
